import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { move } from "../../lib/adminHelpers";
import { ChevronUp, ChevronDown, Eye, EyeOff, GripVertical } from "lucide-react";
import { Button } from "../ui/button";
import { toast } from "sonner";

export const LayoutManager = () => {
  const [secs, setSecs] = useState([]);

  const load = () => api.get("/site-sections").then((r) => setSecs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const persist = async (arr) => {
    setSecs(arr);
    try { await api.put("/admin/site-sections", arr); } catch { toast.error("Save failed"); load(); }
  };
  const reorder = (i, dir) => { const next = move(secs, i, dir); if (next) persist(next); };
  const toggle = (i) => persist(secs.map((s, x) => (x === i ? { ...s, visible: !s.visible } : s)));

  return (
    <div className="max-w-2xl">
      <p className="text-sm text-[#A1A1AA] mb-5">Drag order with the arrows and toggle the eye to show/hide entire sections on your homepage. The hero/top banner always stays first. Changes save instantly.</p>
      <div className="space-y-2">
        {secs.map((s, i) => (
          <div key={s.id} data-testid={`layout-row-${s.id}`} className={`flex items-center justify-between gap-3 rounded-lg border p-3 ${s.visible === false ? "border-white/5 bg-[#0e0f14] opacity-60" : "border-white/10 bg-[#12141A]"}`}>
            <div className="flex items-center gap-3 min-w-0">
              <GripVertical size={16} className="text-[#6b6b73] shrink-0" />
              <span className="font-medium truncate">{s.label}</span>
              {s.visible === false && <span className="text-[10px] uppercase text-[#E0A44F]">hidden</span>}
            </div>
            <div className="flex items-center gap-0.5 shrink-0">
              <Button size="icon" variant="ghost" disabled={i === 0} onClick={() => reorder(i, -1)} data-testid={`layout-${s.id}-up`} className="h-8 w-8 text-[#A1A1AA] hover:text-white disabled:opacity-25"><ChevronUp size={16} /></Button>
              <Button size="icon" variant="ghost" disabled={i === secs.length - 1} onClick={() => reorder(i, 1)} data-testid={`layout-${s.id}-down`} className="h-8 w-8 text-[#A1A1AA] hover:text-white disabled:opacity-25"><ChevronDown size={16} /></Button>
              <Button size="icon" variant="ghost" onClick={() => toggle(i)} data-testid={`layout-${s.id}-hide`} className={`h-8 w-8 ${s.visible === false ? "text-[#E0A44F]" : "text-[#A1A1AA]"} hover:text-white`}>
                {s.visible === false ? <EyeOff size={16} /> : <Eye size={16} />}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
